import { SVGProps } from 'react';

/** Chevron tucking down towards a bar - "minimise this panel out of the way". */
export const MinimizeIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg data-icon width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.5 5.25 8 8.75l3.5-3.5"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M4.5 11.75h7" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  );
};
